import create from "zustand";
export const useStore = create((set, get) => ({
  groupedFilters: [],
  // Criteria's //
  selectedColours: [],
  selectedSizes: [],
  selectedWheelSizes: [],
  selectedBrakeTypes: [],
  selectedCategories: [],
  products: [],
  filteredProducts: [],
  categoryCount: 0,
  fetchProducts: (payload) => {
    let arr = [];
    payload.map((products) => {
      products[1].map((product) => {
        arr.push(product);
      });
    });
    set({ products: arr });
  },
  addOrRemoveFromFilter: (tag, selected, groupedFilters) => {
    if (!selected.includes(tag)) {
      selected.push(tag);
    } else {
      const index = selected.indexOf(tag);
      if (index !== -1) {
        selected.splice(index, 1);
      }
    }

    if (!groupedFilters.includes(tag)) {
      groupedFilters.push(tag);
    } else {
      const i = groupedFilters.indexOf(tag);
      if (i !== -1) {
        groupedFilters.splice(i, 1);
      }
    }
  },
  newFilter: (groupedFilters, selectedFilter) => {
    if (groupedFilters.includes(selectedFilter)) {
      let arr = [];
      get().filteredProducts.map((product) => {
        if (selectedFilter.includes("colour")) {
          let selectedColour = selectedFilter.split(":")[1];
          let productColours = [];
          product.tags.map((tag) => {
            if (tag.includes("colour")) {
              productColours.push(tag.split(":")[1]);
            }
          });
          if (productColours.includes(selectedColour)) {
            arr.push(product);
          }
        }
        if (selectedFilter.includes("bike_sizes")) {
          let selectedSize = selectedFilter.split(":")[1].trim();
          if (product.options[1].values.includes(selectedSize)) {
            arr.push(product);
          }
        }
        if (product.tags.includes(selectedFilter)) {
          arr.push(product);
        }
      });
      if (arr.length == 0) {
        get().fetchFilteredProducts(groupedFilters, get().products);
      } else {
        set({ filteredProducts: arr });
      }
    } else {
      get().fetchFilteredProducts(groupedFilters, get().products);
    }
  },
  fetchFilteredProducts: (groupedFilters, allProducts) => {
    if (groupedFilters.length > 0) {
      let tempArray = [];
      let tempArray1 = [];
      let tempArray2 = [];
      allProducts.filter((product) => {
        let productColours = [];
        product.tags.map((tag) => {
          if (tag.includes("colour")) {
            productColours.push(tag.split(":")[1]);
          }
        });
        if (get().selectedColours.length > 0) {
          groupedFilters.map((colour) => {
            let selectedColour = colour.split(":")[1];
            if (productColours.includes(selectedColour)) {
              tempArray.push(product);
            }
          });
        }
        if (get().selectedSizes.length > 0) {
          groupedFilters.map((size) => {
            if (product.options[1].values.includes(size)) {
              tempArray1.push(product);
            }
          });
        }
        groupedFilters.map((filter) => {
          if (product.tags.includes(filter)) {
            tempArray2.push(product);
          }
        });
      });

      let allArrays = [...tempArray, ...tempArray1, ...tempArray2];

      let unique = [...new Set(allArrays.map((item) => item.title))];
      let newArray = [];

      get().products.map((product) => {
        if (unique.includes(product.title)) {
          newArray.push(product);
        }
      });

      if (newArray.length > 0) {
        set({ filteredProducts: newArray });
      } else {
        set({ filteredProducts: [] });
      }
    } else {
      set({ filteredProducts: [] });
    }
  },
  selectFilter: (payload) => {
    const allProducts = get().products;
    let selectedColours = get().selectedColours;
    let selectedWheelSizes = get().selectedWheelSizes;
    let selectedBrakeTypes = get().selectedBrakeTypes;
    let selectedCategories = get().selectedCategories;
    let selectedSizes = get().selectedSizes;
    let groupedFilters = get().groupedFilters;
    let filteredProducts = get().filteredProducts;

    // colour filters
    if (payload.includes("colour")) {
      get().addOrRemoveFromFilter(payload, selectedColours, groupedFilters);
    }
    // // size filters
    if (payload.includes("sizes")) {
      let tempSize = payload.split(":")[1].trim();
      get().addOrRemoveFromFilter(tempSize, selectedSizes, groupedFilters);
    }
    // wheel filters
    if (payload.includes("wheel")) {
      get().addOrRemoveFromFilter(payload, selectedWheelSizes, groupedFilters);
    }
    // brake filters
    if (payload.includes("brake")) {
      get().addOrRemoveFromFilter(payload, selectedBrakeTypes, groupedFilters);
    }
    // // category filters
    if (payload.includes("category")) {
      get().addOrRemoveFromFilter(payload, selectedCategories, groupedFilters);
    }

    if (filteredProducts.length > 0) {
      get().newFilter(groupedFilters, payload);
    } else {
      get().fetchFilteredProducts(groupedFilters, allProducts);
    }
  },

  getCategoryCount: (criteria, setCount) => {
    let arr = [];

    if (get().filteredProducts.length > 0) {
      get().filteredProducts.map((product) => {
        if (product.tags.includes(criteria)) {
          arr.push(product);
        }
        if (criteria.includes("size")) {
          let tempSize = criteria.split(":")[1].trim();
          if (product.options[1].values.includes(tempSize)) {
            arr.push(product);
          }
        }
        if (criteria.includes("colour")) {
          let productColours = [];
          product.tags.map((tag) => {
            if (tag.includes("colour")) {
              productColours.push(tag.split(":")[1]);
            }
          });
          let selectedColour = criteria.split(":")[1];

          if (productColours.includes(selectedColour)) {
            arr.push(product);
          }
        }
      });
    } else {
      get().products.map((product) => {
        if (product.tags.includes(criteria)) {
          arr.push(product);
        }
        if (criteria.includes("size")) {
          let tempSize = criteria.split(":")[1].trim();
          if (product.options[1].values.includes(tempSize)) {
            arr.push(product);
          }
        }
        if (criteria.includes("colour")) {
          let productColours = [];
          product.tags.map((tag) => {
            if (tag.includes("colour")) {
              productColours.push(tag.split(":")[1]);
            }
          });
          let selectedColour = criteria.split(":")[1];

          if (productColours.includes(selectedColour)) {
            arr.push(product);
          }
        }
      });
    }

    setCount(arr.length);
  },
}));
